import config from 'config';

export const isSCIPXPolicy = (policyNumber) => {
  if (!policyNumber || typeof policyNumber !== 'string') {
    return null;
  }

  const scPrefixes = ['SCH6', 'SCH3', 'SC6', 'SC3'];
  if (
    scPrefixes.some((prefix) => policyNumber.startsWith(prefix)) &&
    policyNumber.length === 10
  ) {
    return true;
  }

  return false;
};

export const isIPXFLDP1Policy = (policyNumber) => {
  if (!policyNumber || typeof policyNumber !== 'string') {
    return null;
  }

  const pattern = config.appEnv === 'PROD' ? /^SIF\d{7}$/ : /^SF1\d{7}$/;
  return pattern.test(policyNumber);
};

export const isSCVioletPolicy = (policyNumber) => {
  if (!policyNumber || typeof policyNumber !== 'string') {
    return null;
  }

  const scPrefixes = ['HOSC', 'H6SC'];
  if (scPrefixes.some((prefix) => policyNumber.startsWith(prefix))) {
    return true;
  }

  return false;
};

export const isD3RIPolicy = (policyNumber) => {
  if (!policyNumber || typeof policyNumber !== 'string') {
    return null;
  }

  const riDp3Prefixes = ['D3RI'];
  if (riDp3Prefixes.some((prefix) => policyNumber.startsWith(prefix))) {
    return true;
  }

  return false;
};

export const isH3TXPolicy = (policyNumber) => {
  if (!policyNumber || typeof policyNumber !== 'string') {
    return null;
  }

  const txHo3Prefixes = ['H3TX'];
  if (txHo3Prefixes.some((prefix) => policyNumber.startsWith(prefix))) {
    return true;
  }

  return false;
};

export const isD1FLPolicy = (policyNumber) => {
  if (!policyNumber || typeof policyNumber !== 'string') {
    return null;
  }

  return /^D1FL\d{9}$/.test(policyNumber);
};

export const isFusionNonHurricane = (policy) => {
  if (!policy?.policyNumber || !policy.isFusion) {
    return null;
  }

  return policy?.lineType === 'PersonalHomeNonHurricane';
};

export const isInactivePolicy = (policyStatus) => {
  if (!policyStatus || typeof policyStatus !== 'string') {
    return null;
  }

  const inactiveStatus = ['Inactive', 'Cancelled'];
  if (inactiveStatus.some((status) => policyStatus === status)) {
    return true;
  }

  return false;
};

export const isSSICPolicy = (policyNumber, policySystem) => {
  if (!policyNumber || typeof policyNumber !== 'string') {
    return null;
  }

  const violetPrefixes = [
    'D3RI',
    'HOSC',
    'H6SC',
    'H3NJ',
    'H6NJ',
    'H3NY',
    'H6NY',
  ];
  if (
    policySystem === 'Violet' &&
    violetPrefixes.some((prefix) => policyNumber.startsWith(prefix)) &&
    policyNumber.length === 13
  ) {
    return true;
  }

  return false;
};

export const WEST_POINT_POLICY_PREFIXES = ['MHP', 'HWP'];

export const isWestPointPolicyNumber = (policyNumber) => {
  if (!policyNumber || typeof policyNumber !== 'string') {
    return false;
  }

  const sanitized = policyNumber.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

  return WEST_POINT_POLICY_PREFIXES.some((prefix) =>
    sanitized.startsWith(prefix),
  );
};

export const isCompany = (policy) => {
  const policyType = policy?.policyType;
  if (policyType != null && policyType !== '') {
    return String(policyType).toLowerCase() === 'corporation';
  }

  return (
    policy?.insured?.firstName === '' &&
    (policy?.insured?.lastName === '' ||
      policy?.insured?.lastName.trim() === policy?.organizationName?.trim())
  );
};

export default {
  isSCIPXPolicy,
  isSCVioletPolicy,
  isD3RIPolicy,
  isH3TXPolicy,
  isD1FLPolicy,
  isIPXFLDP1Policy,
  isFusionNonHurricane,
  isInactivePolicy,
  isSSICPolicy,
  isCompany,
  isWestPointPolicyNumber,
};
